export const workNestPalette = {
  primary: "#12054d",
  secondary: "#7a5cf0",
};
